<template>
    <div style="margin-top: 30px;">
          <div style="margin: 20px;"> 欢迎来到访客后台管理系统!</div>
  </div>
</template>

<script>
  
  
  export default {
        name: "Welcome",
        mounted() {
            var curTime = new Date()
            if(window.localStorage.TokenExpire){
                var expiretime = new Date(Date.parse(window.localStorage.TokenExpire))
                if(curTime>=expiretime){
                    this.$router.push('/login');
                }
            }else {
                 this.$router.push('/login');
                
            }

        },
    }
    
</script>

<style scoped>
.note .text {
    font-size: 14px;
  }

 .note .item {
    margin-bottom: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Welcome.vue